import React from 'react';
import { siteData } from '../data/mock';
import * as LucideIcons from 'lucide-react';
import { CheckCircle2 } from 'lucide-react';

const SolutionsSection = () => {
  const getIcon = (iconName) => {
    const Icon = LucideIcons[iconName];
    return Icon || LucideIcons.Circle;
  };

  return (
    <section id="solutions" className="section section-alt">
      <div className="container">
        <div className="max-w-4xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 border border-blue-100 mb-6">
              <CheckCircle2 size={16} className="text-blue-600" />
              <span className="text-sm font-medium text-blue-700">Solução</span>
            </div>
            <h2 className="heading-2">{siteData.solutions.title}</h2>
          </div>

          {/* Solution cards grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
            {siteData.solutions.items.map((item, index) => {
              const Icon = getIcon(item.icon);
              return (
                <div key={index} className="card-solution group">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center flex-shrink-0 group-hover:bg-blue-100 transition-colors">
                      <Icon size={22} className="text-blue-600" />
                    </div>
                    <p className="text-sm font-medium text-slate-700">{item.text}</p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Impact statement */}
          <div className="text-center">
            <p className="text-xl font-semibold text-slate-800 px-6 py-5 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl border border-blue-100 inline-block">
              {siteData.solutions.impact}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
